module.exports = __webpack_public_path__ + "img/07351af.jpg";